import { apiClient } from "../api/apiclient"

export const getCourse = (token) =>
    apiClient.get("/courses", {
        headers: { Authorization: `Bearer ${token}` },
    });


export const getRegisFees = (token) =>
    apiClient.get("/registration-fees/all", {
        headers: { Authorization: `Bearer ${token}` },

    });


export const PostRegisFees = (request, token) =>
    apiClient.post("/registration-fees", request,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );


// export const updateRegistrationFees = (token, request) =>
//     apiClient.put("/registration-fees", {
//         courseId: request.courseIds[0], // Assuming only one course per registration
//         fees: request.fees,
//         active: request.active,
//     }, {
//         headers: { Authorization: `Bearer ${token}` },
//     });

export const updateRegistrationFees = (request, token) =>
    apiClient.put("/registration-fees", request, {
        headers: { Authorization: `Bearer ${token}` },
    }
    );